import React from 'react'

import { Ac } from './ac'
import { Ad } from './ad'
import { Ae } from './ae'
import { Af } from './af'
import { Ag } from './ag'
import { Ai } from './ai'
import { Al } from './al'
import { Am } from './am'
import { An } from './an'
import { Ao } from './ao'
import { Aq } from './aq'
import { Ar } from './ar'
import { As } from './as'
import { At } from './at'
import { Au } from './au'
import { Aw } from './aw'
import { Ax } from './ax'
import { Az } from './az'
import { Ba } from './ba'
import { Bb } from './bb'
import { Bd } from './bd'
import { Be } from './be'
import { Bf } from './bf'
import { Bg } from './bg'
import { Bh } from './bh'
import { Bi } from './bi'
import { Bj } from './bj'
import { Bl } from './bl'
import { Bm } from './bm'
import { Bn } from './bn'
import { Bo } from './bo'
import { Bq } from './bq'
import { Br } from './br'
import { Bs } from './bs'
import { Bt } from './bt'
import { Bv } from './bv'
import { Bw } from './bw'
import { By } from './by'
import { Bz } from './bz'
import { Ca } from './ca'
import { Cc } from './cc'
import { Cd } from './cd'
import { Cf } from './cf'
import { Cg } from './cg'
import { Ch } from './ch'
import { Ci } from './ci'
import { Ck } from './ck'
import { Cl } from './cl'
import { Cm } from './cm'
import { Cn } from './cn'
import { Co } from './co'
import { Cr } from './cr'
import { Cu } from './cu'
import { Cv } from './cv'
import { Cw } from './cw'
import { Cx } from './cx'
import { Cy } from './cy'
import { Cz } from './cz'
import { De } from './de'
import { Dj } from './dj'
import { Dk } from './dk'
import { Dm } from './dm'
import { Do } from './do'
import { Dz } from './dz'
import { Ec } from './ec'
import { Ee } from './ee'
import { Eg } from './eg'
import { Eh } from './eh'
import { Er } from './er'
import { Es } from './es'
import { Et } from './et'
import { Eu } from './eu'
import { Fi } from './fi'
import { Fj } from './fj'
import { Fk } from './fk'
import { Fm } from './fm'
import { Fo } from './fo'
import { Fr } from './fr'
import { Ga } from './ga'
import { Gb } from './gb'
import { Gd } from './gd'
import { Ge } from './ge'
import { GeAb } from './geAb'
import { GeOs } from './geOs'
import { Gf } from './gf'
import { Gg } from './gg'
import { Gh } from './gh'
import { Gi } from './gi'
import { Gl } from './gl'
import { Gm } from './gm'
import { Gn } from './gn'
import { Gp } from './gp'
import { Gq } from './gq'
import { Gr } from './gr'
import { Gs } from './gs'
import { Gt } from './gt'
import { Gu } from './gu'
import { Gw } from './gw'
import { Gy } from './gy'
import { Hk } from './hk'
import { Hm } from './hm'
import { Hn } from './hn'
import { Hr } from './hr'
import { Ht } from './ht'
import { Hu } from './hu'
import { Ic } from './ic'
import { Id } from './id'
import { Ie } from './ie'
import { Il } from './il'
import { Im } from './im'
import { In } from './in'
import { Io } from './io'
import { Iq } from './iq'
import { Ir } from './ir'
import { Is } from './is'
import { It } from './it'
import { Je } from './je'
import { Jm } from './jm'
import { Jo } from './jo'
import { Jp } from './jp'
import { Ke } from './ke'
import { Kg } from './kg'
import { Kh } from './kh'
import { Ki } from './ki'
import { Km } from './km'
import { Kn } from './kn'
import { Kp } from './kp'
import { Kr } from './kr'
import { Kw } from './kw'
import { Ky } from './ky'
import { Kz } from './kz'
import { La } from './la'
import { Lb } from './lb'
import { Lc } from './lc'
import { Li } from './li'
import { Lk } from './lk'
import { Lr } from './lr'
import { Ls } from './ls'
import { Lt } from './lt'
import { Lu } from './lu'
import { Lv } from './lv'
import { Ly } from './ly'
import { Ma } from './ma'
import { Mc } from './mc'
import { Md } from './md'
import { Me } from './me'
import { Mf } from './mf'
import { Mg } from './mg'
import { Mh } from './mh'
import { Mk } from './mk'
import { Ml } from './ml'
import { Mm } from './mm'
import { Mn } from './mn'
import { Mo } from './mo'
import { Mp } from './mp'
import { Mq } from './mq'
import { Mr } from './mr'
import { Ms } from './ms'
import { Mt } from './mt'
import { Mu } from './mu'
import { Mv } from './mv'
import { Mw } from './mw'
import { Mx } from './mx'
import { My } from './my'
import { Mz } from './mz'
import { Na } from './na'
import { Nc } from './nc'
import { Ne } from './ne'
import { Nf } from './nf'
import { Ng } from './ng'
import { Ni } from './ni'
import { Nl } from './nl'
import { No } from './no'
import { Np } from './np'
import { Nr } from './nr'
import { Nu } from './nu'
import { Nz } from './nz'
import { Om } from './om'
import { Pa } from './pa'
import { Pe } from './pe'
import { Pf } from './pf'
import { Pg } from './pg'
import { Ph } from './ph'
import { Pk } from './pk'
import { Pl } from './pl'
import { Pm } from './pm'
import { Pn } from './pn'
import { Pr } from './pr'
import { Ps } from './ps'
import { Pt } from './pt'
import { Pw } from './pw'
import { Py } from './py'
import { Qa } from './qa'
import { Re } from './re'
import { Ro } from './ro'
import { Rs } from './rs'
import { Ru } from './ru'
import { Rw } from './rw'
import { Sa } from './sa'
import { Sb } from './sb'
import { Sc } from './sc'
import { Sd } from './sd'
import { Se } from './se'
import { Sg } from './sg'
import { Sh } from './sh'
import { Si } from './si'
import { Sj } from './sj'
import { Sk } from './sk'
import { Sl } from './sl'
import { Sm } from './sm'
import { Sn } from './sn'
import { So } from './so'
import { Sr } from './sr'
import { Ss } from './ss'
import { St } from './st'
import { Sv } from './sv'
import { Sx } from './sx'
import { Sy } from './sy'
import { Sz } from './sz'
import { Ta } from './ta'
import { Tc } from './tc'
import { Td } from './td'
import { Tf } from './tf'
import { Tg } from './tg'
import { Th } from './th'
import { Tj } from './tj'
import { Tk } from './tk'
import { Tl } from './tl'
import { Tm } from './tm'
import { Tn } from './tn'
import { To } from './to'
import { Tr } from './tr'
import { Tt } from './tt'
import { Tv } from './tv'
import { Tw } from './tw'
import { Tz } from './tz'
import { Ua } from './ua'
import { Ug } from './ug'
import { Um } from './um'
import { Us } from './us'
import { Uy } from './uy'
import { Uz } from './uz'
import { Va } from './va'
import { Vc } from './vc'
import { Ve } from './ve'
import { Vg } from './vg'
import { Vi } from './vi'
import { Vn } from './vn'
import { Vu } from './vu'
import { Wf } from './wf'
import { Ws } from './ws'
import { Xk } from './xk'
import { Ye } from './ye'
import { Yt } from './yt'
import { Za } from './za'
import { Zm } from './zm'
import { Zw } from './zw'

export const Flags: Record<string, React.ReactElement> = {
  ac: <Ac />,
  ad: <Ad />,
  ae: <Ae />,
  af: <Af />,
  ag: <Ag />,
  ai: <Ai />,
  al: <Al />,
  am: <Am />,
  an: <An />,
  ao: <Ao />,
  aq: <Aq />,
  ar: <Ar />,
  as: <As />,
  at: <At />,
  au: <Au />,
  aw: <Aw />,
  ax: <Ax />,
  az: <Az />,
  ba: <Ba />,
  bb: <Bb />,
  bd: <Bd />,
  be: <Be />,
  bf: <Bf />,
  bg: <Bg />,
  bh: <Bh />,
  bi: <Bi />,
  bj: <Bj />,
  bl: <Bl />,
  bm: <Bm />,
  bn: <Bn />,
  bo: <Bo />,
  bq: <Bq />,
  br: <Br />,
  bs: <Bs />,
  bt: <Bt />,
  bv: <Bv />,
  bw: <Bw />,
  by: <By />,
  bz: <Bz />,
  ca: <Ca />,
  cc: <Cc />,
  cd: <Cd />,
  cf: <Cf />,
  cg: <Cg />,
  ch: <Ch />,
  ci: <Ci />,
  ck: <Ck />,
  cl: <Cl />,
  cm: <Cm />,
  cn: <Cn />,
  co: <Co />,
  cr: <Cr />,
  cu: <Cu />,
  cv: <Cv />,
  cw: <Cw />,
  cx: <Cx />,
  cy: <Cy />,
  cz: <Cz />,
  de: <De />,
  dj: <Dj />,
  dk: <Dk />,
  dm: <Dm />,
  do: <Do />,
  dz: <Dz />,
  ec: <Ec />,
  ee: <Ee />,
  eg: <Eg />,
  eh: <Eh />,
  er: <Er />,
  es: <Es />,
  et: <Et />,
  eu: <Eu />,
  fi: <Fi />,
  fj: <Fj />,
  fk: <Fk />,
  fm: <Fm />,
  fo: <Fo />,
  fr: <Fr />,
  ga: <Ga />,
  gb: <Gb />,
  gd: <Gd />,
  ge: <Ge />,
  geAb: <GeAb />,
  geOs: <GeOs />,
  gf: <Gf />,
  gg: <Gg />,
  gh: <Gh />,
  gi: <Gi />,
  gl: <Gl />,
  gm: <Gm />,
  gn: <Gn />,
  gp: <Gp />,
  gq: <Gq />,
  gr: <Gr />,
  gs: <Gs />,
  gt: <Gt />,
  gu: <Gu />,
  gw: <Gw />,
  gy: <Gy />,
  hk: <Hk />,
  hm: <Hm />,
  hn: <Hn />,
  hr: <Hr />,
  ht: <Ht />,
  hu: <Hu />,
  ic: <Ic />,
  id: <Id />,
  ie: <Ie />,
  il: <Il />,
  im: <Im />,
  in: <In />,
  io: <Io />,
  iq: <Iq />,
  ir: <Ir />,
  is: <Is />,
  it: <It />,
  je: <Je />,
  jm: <Jm />,
  jo: <Jo />,
  jp: <Jp />,
  ke: <Ke />,
  kg: <Kg />,
  kh: <Kh />,
  ki: <Ki />,
  km: <Km />,
  kn: <Kn />,
  kp: <Kp />,
  kr: <Kr />,
  kw: <Kw />,
  ky: <Ky />,
  kz: <Kz />,
  la: <La />,
  lb: <Lb />,
  lc: <Lc />,
  li: <Li />,
  lk: <Lk />,
  lr: <Lr />,
  ls: <Ls />,
  lt: <Lt />,
  lu: <Lu />,
  lv: <Lv />,
  ly: <Ly />,
  ma: <Ma />,
  mc: <Mc />,
  md: <Md />,
  me: <Me />,
  mf: <Mf />,
  mg: <Mg />,
  mh: <Mh />,
  mk: <Mk />,
  ml: <Ml />,
  mm: <Mm />,
  mn: <Mn />,
  mo: <Mo />,
  mp: <Mp />,
  mq: <Mq />,
  mr: <Mr />,
  ms: <Ms />,
  mt: <Mt />,
  mu: <Mu />,
  mv: <Mv />,
  mw: <Mw />,
  mx: <Mx />,
  my: <My />,
  mz: <Mz />,
  na: <Na />,
  nc: <Nc />,
  ne: <Ne />,
  nf: <Nf />,
  ng: <Ng />,
  ni: <Ni />,
  nl: <Nl />,
  no: <No />,
  np: <Np />,
  nr: <Nr />,
  nu: <Nu />,
  nz: <Nz />,
  om: <Om />,
  pa: <Pa />,
  pe: <Pe />,
  pf: <Pf />,
  pg: <Pg />,
  ph: <Ph />,
  pk: <Pk />,
  pl: <Pl />,
  pm: <Pm />,
  pn: <Pn />,
  pr: <Pr />,
  ps: <Ps />,
  pt: <Pt />,
  pw: <Pw />,
  py: <Py />,
  qa: <Qa />,
  re: <Re />,
  ro: <Ro />,
  rs: <Rs />,
  ru: <Ru />,
  rw: <Rw />,
  sa: <Sa />,
  sb: <Sb />,
  sc: <Sc />,
  sd: <Sd />,
  se: <Se />,
  sg: <Sg />,
  sh: <Sh />,
  si: <Si />,
  sj: <Sj />,
  sk: <Sk />,
  sl: <Sl />,
  sm: <Sm />,
  sn: <Sn />,
  so: <So />,
  sr: <Sr />,
  ss: <Ss />,
  st: <St />,
  sv: <Sv />,
  sx: <Sx />,
  sy: <Sy />,
  sz: <Sz />,
  ta: <Ta />,
  tc: <Tc />,
  td: <Td />,
  tf: <Tf />,
  tg: <Tg />,
  th: <Th />,
  tj: <Tj />,
  tk: <Tk />,
  tl: <Tl />,
  tm: <Tm />,
  tn: <Tn />,
  to: <To />,
  tr: <Tr />,
  tt: <Tt />,
  tv: <Tv />,
  tw: <Tw />,
  tz: <Tz />,
  ua: <Ua />,
  ug: <Ug />,
  um: <Um />,
  us: <Us />,
  uy: <Uy />,
  uz: <Uz />,
  va: <Va />,
  vc: <Vc />,
  ve: <Ve />,
  vg: <Vg />,
  vi: <Vi />,
  vn: <Vn />,
  vu: <Vu />,
  wf: <Wf />,
  ws: <Ws />,
  xk: <Xk />,
  ye: <Ye />,
  yt: <Yt />,
  za: <Za />,
  zm: <Zm />,
  zw: <Zw />,
}
